export const AUTH_CALLBACK_PATH = '/auth/callback';
export const LOGIN_PATH = '/login';
